import { useTimeoutFunction } from 'hooks/useTimeoutFunction';
import { useEffect } from 'react';

export const useDocumentTimeout = ({ startCondition, callback, timeLapse }, dependencies) => {
    const { resetTimeoutFunction, startTimeoutFunction, stopTimeoutFunction } = useTimeoutFunction(
        () => onTimeout(),
        timeLapse
    );

    const onTimeout = () => {
        stopTimeoutFunction();
        callback();
    };

    useEffect(() => {
        startCondition && startTimeoutFunction();
        /* eslint-disable-next-line react-hooks/exhaustive-deps */
    }, dependencies);

    return { resetTimeoutFunction, stopTimeoutFunction };
};
